const IconClose = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={9}
      height={9}
      fill="none"
      viewBox="0 0 9 9"
    >
      <path
        d="M0.75 7.75L7.75 0.75M0.75 0.75L7.75 7.75" stroke="#E01313" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  )
}

export default IconClose;
